/**
 * Fixed deals shell header metrics — keep scroll `padding-top` in sync with
 * `DealsTabsContainer` and standalone restaurant routes.
 */
export const DEALS_HEADER_TOP_GAP_PX = 12;
/** Row fits frosted tab pill + icon buttons; keep ≥ actual header row height to avoid search bar underlap. */
export const DEALS_HEADER_ROW_MIN_HEIGHT_PX = 54;
export const DEALS_HEADER_BOTTOM_PADDING_PX = 12;

/** Total inset below viewport top (safe area is added in CSS expr separately). */
export const DEALS_CONTENT_TOP_PADDING_PX =
  DEALS_HEADER_TOP_GAP_PX +
  DEALS_HEADER_ROW_MIN_HEIGHT_PX +
  DEALS_HEADER_BOTTOM_PADDING_PX;

/** Scrollable region `padding-top` under fixed header (includes safe area). */
export const dealsScrollContentPaddingTop = `calc(env(safe-area-inset-top, 0px) + ${DEALS_CONTENT_TOP_PADDING_PX}px)`;
